export const STATEDASHBOARDUSER = "State Dashboard"
export const ADMIN = "Admin"
export const ULBADMIN = "ULB Admin"
export const SCHEDULER = "Scheduler"